import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ProductExtensionEntities, State } from '../models';

import { customerProductIdentifiersFeatureKey } from './customer-product-identifiers.reducer';

export const selectCustomerProductIdentifiersState = createFeatureSelector<
  State
>(customerProductIdentifiersFeatureKey);

export const selectProductExtensions = createSelector(
  selectCustomerProductIdentifiersState,
  (state) => state.productExtensions,
);

export const selectExtensionsForProduct = (productId: string) =>
  createSelector(
    selectProductExtensions,
    (identifiers: ProductExtensionEntities) => {
      return identifiers[productId];
    },
  );

export const selectLoaded = createSelector(
  selectCustomerProductIdentifiersState,
  (state) => state.loaded,
);
